import { Component } from "react";
import {
  numberWithoutSpaces,
  numberWithSpaces,
} from "../../utilities/formaters";

import TextField from "@material-ui/core/TextField";
import PropTypes from "prop-types";

export default class Currency extends Component {
  changeCurrency(event) {
    let value = numberWithoutSpaces(event.target.value);
    event.target.value = value;
    this.props.onChange(event, value);
  }

  blurCurrency(event) {
    if (this.props.onBlur) {
      let value = numberWithoutSpaces(event.target.value);
      event.target.value = value;
      this.props.onBlur(event, value);
    }
  }

  render() {
    return (
      <TextField
        size="small"
        variant="outlined"
        {...this.props}
        value={numberWithSpaces(this.props.value)}
        onBlur={this.blurCurrency.bind(this)}
        onChange={this.changeCurrency.bind(this)}
      />
    );
  }

  static propTypes = {
    label: PropTypes.string,
    value: PropTypes.any,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
  };
}
